import React from 'react';
import { ContainerTexto, Title, TitleContainer, Text, FixedAnchor } from '../styles';

import video from '../../../assets/video/solicitacao_de_retorno.mp4'
import { VideoPlayer } from 'components/_REFACTORED/VideoPlayer';
import { Anchor } from 'antd';

const SolicRetorno: React.FC = () => {

  const { Link } = Anchor
  return (
    <>
      <ContainerTexto>
        <TitleContainer id="solicitacao-inicio">Solicitação de Retorno</TitleContainer>
        <VideoPlayer videoFile={video} />
        <Text>
          Em ‘Solicitações de Retorno’ o usuário poderá consultar e exportar seus pedidos de retorno
          de mercadoria. Ele poderá ver todos seus pedidos e acompanhar suas movimentações durante o
          processo de retorno.
        </Text>

        <Title id="solicitacao-info">Informações Principais</Title>
        <Text>
          A tela conta com uma listagem com as informações de número único no Sankhya, número do
          pedido, número da nota, data e hora da solicitação, status de retorno, inscrição estadual
          e nome do depositante da nota, pagador da armazenagem, peso bruto e valor da mercadoria do
          pedido, de todos os pedidos de solicitação de retorno das inscrições estaduais
          selecionadas no cabeçalho, no centro de distribuição selecionado.
        </Text>

        <Title id="solicitacao-infoAdicionais">Informações adicionais</Title>

        <Text>
          Além disso, a expansão do pedido conta com uma linha do tempo informando a etapa atual do
          processo de solicitação, bem como a data e hora de cada uma das etapas que já foi feita, e
          quais etapas ainda faltam para a finalização do processo de solicitação.
        </Text>

        <Title id="solicitacao-produtos">Produtos da nota</Title>

        <Text>
          O usuário também pode visualizar detalhes dos produtos de cada pedido clicando no número
          único (em azul) na listagem. Ele será apresentado por uma segunda listagem que contém as
          informações de código do produto, código de referência, nome do produto, lote, quantidade
          solicitada, unidade de do produto, peso bruto e valor total, para cada um dos produtos da
          solicitação de retorno.
        </Text>

        <Title id="solicitacao-acoes">Ações</Title>
        <Text>
          O usuário poderá ainda cancelar o pedido de solicitação de retorno (se este ainda não
          estiver no status ‘Pedido Confirmado’), imprimir uma guia de solicitação de retorno de
          mercadoria para aquele pedido e editar a transportadora (ou cliente retira) daquele pedido
          (se este ainda não estiver no status ‘Agendado’).
        </Text>

        <Title id="solicitacao-filtros">Filtros</Title>
        <Text>
          Por fim, a tela também conta com os filtros de número único, número da nota, status,
          pagador da armazenagem, período de solicitação e depositante.
        </Text>
      </ContainerTexto>

      <FixedAnchor>
        <Link title="Início" href='#solicitacao-inicio' />
        <Link title="Informações Principais" href='#solicitacao-info' />
        <Link title="Informações Adicionais" href='#solicitacao-infoAdicionais' />
        <Link title="Produtos" href='#solicitacao-produtos' />
        <Link title="Ações" href='#solicitacao-acoes' />
        <Link title="Filtros" href='#solicitacao-filtros' />
      </FixedAnchor>
    </>

  );
};

export default SolicRetorno;
